import AimMac from './components/AimMac';

export default AimMac;
